import { I18n } from '@calendly/i18n'
import { IconButton } from '@calendly/ui/components/icon-button'
import { CloseIcon } from '@calendly/ui/components/icons'

import { useUpdateAvailabilityScheduleMutation } from '../../api'

export const CloseControl = ({ selectedScheduleId, onClose }) => {
  const [_, { isLoading }] = useUpdateAvailabilityScheduleMutation({
    fixedCacheKey: `update-availability-schedule-${selectedScheduleId}`
  })

  return (
    <IconButton
      size="small"
      title={I18n.t('publisher.action.cancel')}
      onClick={onClose}
      disabled={isLoading}
    >
      <CloseIcon />
    </IconButton>
  )
}
